import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { createFirm } from '../lib/api';
import { friendlyError } from '../lib/format';
import { Button, ErrorText, TextField } from '../components/ui';

export function Onboarding() {
  const { reload, signOut, session } = useAuth();
  const [name, setName] = useState('');
  const [fullName, setFullName] = useState('');
  const [city, setCity] = useState('Gurugram');
  const [rera, setRera] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      await createFirm({ name, fullName, city, rera });
      await reload();
    } catch (err) {
      setError(friendlyError(err));
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-8">
      <div className="w-full max-w-[460px]">
        <p className="font-display text-3xl">Set up your firm</p>
        <p className="mb-6 text-muted">You'll be the owner. You can invite your managers and reps next.
          If someone invited you, open the link from their invite instead.</p>
        <form onSubmit={submit} className="flex flex-col gap-4 rounded-2xl border border-line bg-surface p-5">
          <TextField label="Firm name" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Northgate Realty" />
          <TextField label="Your name" required value={fullName} onChange={(e) => setFullName(e.target.value)} />
          <TextField label="City" value={city} onChange={(e) => setCity(e.target.value)} />
          <TextField label="Firm's RERA agent number" value={rera} onChange={(e) => setRera(e.target.value)}
            hint="Optional now. Posts will need it later." />
          <ErrorText>{error}</ErrorText>
          <Button variant="primary" type="submit" disabled={busy}>{busy ? 'Creating…' : 'Create firm'}</Button>
        </form>
        <p className="mt-4 text-center text-sm text-muted">Signed in as {session?.user.email} · <button className="hover:text-accent" onClick={signOut}>Sign out</button></p>
      </div>
    </div>
  );
}
